import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class FacilityName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): FacilityName {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new FacilityName(value);
  }

  /** ラベル */
  static get label(): string {
    return '施設名';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'サンプル子ども園';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'facilityName';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
